export const useSlot = () => {
  const hasSlot = (slotName = 'default') => {
    const slots = useSlots();
    return Boolean(slots[slotName]);
  };
  return {
    hasSlot
  };
};
